import { ref } from 'vue';
import { EcommerceProductReview } from '@zyro-inc/site-modules/types';
import StoreApi from '@zyro-inc/site-modules/api/StoreApi';

const DEFAULT_REVIEWS_PAGE_SIZE_LIMIT = 25;

export const useProductReviewsList = () => {
	const productReviewsList = ref<EcommerceProductReview[]>([]);
	const isLoading = ref(false);
	const limit = ref(DEFAULT_REVIEWS_PAGE_SIZE_LIMIT);
	const count = ref(0);
	const rating = ref<number | null>(null);

	const fetchProductReviewsChunk = async ({
		storeId,
		productId,
	}: {
		storeId: string;
		productId: string;
	}) => {
		isLoading.value = true;

		try {
			const {
				reviews,
				count: reviewCount,
			} = await StoreApi.getReviews({
				storeId,
				productId,
				queryParams: {
					limit: limit.value,
					offset: productReviewsList.value.length,
					...(rating.value && {
						rating: rating.value,
					}),
				},
			});

			productReviewsList.value = [
				...productReviewsList.value,
				...reviews,
			];
			count.value = reviewCount;
		} catch (error) {
			console.error(error);
		} finally {
			isLoading.value = false;
		}
	};

	const resetProductReviewsList = () => {
		productReviewsList.value = [];
		count.value = 0;
		rating.value = null;
	};

	return {
		productReviewsList,
		isLoading,
		limit,
		count,
		fetchProductReviewsChunk,
		rating,
		resetProductReviewsList,
	};
};
